import { Component, OnInit } from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import { FormInlineRowComponent } from './../forms/form-inline-row';
import { UserService } from './user-service';
import { MessageComponent, BaseComponent } from './../common/common-components';
import { request } from 'https';
declare var ga: any;

@Component({
    selector: 'dk-user-transaction-limit',
    template: require('./user-transaction-limit.html'),
    entryComponents: [FormInlineRowComponent]
})

export class UserTransactionLimitComponent extends BaseComponent implements OnInit {
    account: any = null;
    changeSuccess: boolean;
    changeFailure: boolean;
    editMode: boolean;

    form: FormGroup = new FormGroup({
        Pesel: new FormControl('', [Validators.required,
        Validators.pattern("^[0-9]{11}$")]),
        DocumentNumber: new FormControl('', Validators.required),
        DocumentExpirationDate: new FormControl(null, Validators.required)
    });

    constructor(private userService: UserService) {
        super();
    }

    load() {
        this.userService.account().subscribe(data => {
            this.account = data;
            if (this.account.Pesel) {
                this.editMode = true;
                this.initFormGroup(this.form, data);
            }
        });
    }

    ngOnInit() {
        this.load();
    }

    submit() {
        this.changeSuccess = false;
        this.changeFailure = false;
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            this.userService.changeLimitData(this.form.value).subscribe(result => {
                if (result) {
                    this.changeSuccess = true;
                    ga('send', 'event', 'user', 'zapisano-dane-użytkownika', null, null, this.form.value);
                    this.load();
                } else {
                    this.changeFailure = true;
                }
            });
        }
    }
}
